/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jade_Loud_Lark_BoltInputs */

const en_jade_loud_lark_bolt = /** @type {(inputs: Jade_Loud_Lark_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filters`)
};

const de_jade_loud_lark_bolt = /** @type {(inputs: Jade_Loud_Lark_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

/**
* | output |
* | --- |
* | "Filters" |
*
* @param {Jade_Loud_Lark_BoltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_loud_lark_bolt = /** @type {((inputs?: Jade_Loud_Lark_BoltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Loud_Lark_BoltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_loud_lark_bolt(inputs)
	return de_jade_loud_lark_bolt(inputs)
});